import React__default from 'react';
import { KeyboardNavigation } from '../../../KeyboardNavigation/KeyboardNavigation.mjs';
import { usePopoverContext } from '../../editor/plugins/shared/components/Popover/Popover.mjs';

function EditorKeyboardNavigation({
  children
}) {
  const {
    hidePopovers
  } = usePopoverContext();
  return /*#__PURE__*/React__default.createElement(KeyboardNavigation, {
    onEscape: hidePopovers
  }, children);
}

export { EditorKeyboardNavigation };
